import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  flightRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 20px',
    gap: '12px',
    width: '100%',
    boxSizing: 'border-box',
    [Theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      gap: '8px',
      padding: '12px 16px',
    },
  },
  airlineBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: '120px',
    [Theme.breakpoints.down('md')]: {
      minWidth: '110px',
    },
    [Theme.breakpoints.down('sm')]: {
      flex: '1 1 100%',
      minWidth: 'auto',
    },
  },
  airlineLogo: {
    width: '24px',
    height: '24px',
    flexShrink: 0,
  },
  airlineText: {
    '& > p': { margin: 0 },
  },
  airlineName: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[750],
    margin: 0,
    whiteSpace: 'nowrap',
  },
  flightCode: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
  },
  operatedBy: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    margin: 0,
  },
  divider: {
    width: '1px',
    alignSelf: 'stretch',
    backgroundColor: Theme.palette.gray[250],
    flexShrink: 0,
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  departureBlock: {
    textAlign: 'left',
    minWidth: '60px',
    '& > p': { margin: 0 },
    [Theme.breakpoints.down('sm')]: {
      minWidth: '50px',
    },
  },
  arrivalBlock: {
    textAlign: 'right',
    minWidth: '60px',
    '& > p': { margin: 0 },
    [Theme.breakpoints.down('sm')]: {
      minWidth: '50px',
    },
  },
  time: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[4],
    color: Theme.palette.gray[750],
    margin: 0,
    whiteSpace: 'nowrap',
  },
  airportCode: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    margin: 0,
  },
  dayOffset: {
    fontSize: Theme.typography.size[0],
    color: Theme.palette.primary.light,
    verticalAlign: 'super',
    marginLeft: '2px',
  },
  routeBlock: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '3px',
    minWidth: 0,
    [Theme.breakpoints.down('sm')]: {
      flex: '1 1 auto',
    },
  },
  routeLabel: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    margin: 0,
    whiteSpace: 'nowrap',
  },
  routeLine: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  line: {
    flex: 1,
    height: 0,
    borderTop: `1px dashed ${Theme.palette.gray[300]}`,
  },
  routeDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: Theme.palette.gray[750],
    flexShrink: 0,
  },
  routeIcon: {
    fontSize: '16px',
    color: Theme.palette.gray[400],
    flexShrink: 0,
    margin: '0 4px',
    transform: 'rotate(90deg)',
  },
}));

export default useStyles;
